import type { ComponentProps } from 'react'
import { useNavigate } from 'react-router-dom'
import { GameWindow } from '../ui/GameWindow'

/** Dismiss a regular screen without leaving the hero's current place. */
export function LocationWindow(props: Omit<ComponentProps<typeof GameWindow>, 'onClose' | 'closeLabel'>) {
  const navigate = useNavigate()
  return <GameWindow {...props} onClose={() => navigate('/play')} closeLabel="Закрыть окно — вернуться в локацию" />
}
